export class Authentication {
    key: string;
    success = false;
    username: string;

}

export class LoginErrorResponse {
    reason: string;
    skip_login_redir: boolean;
    success: boolean;
}
